/**
 * Created by PuTi(编程即菩提) 7/7/17.
 */
var nb = require('../../../core/js/nb');
var Page = nb.define({
    parent: nb.View,
    view: {
        'class': 'nb-page'
    }
});

module.exports = Page;


//////////////////
// WEBPACK FOOTER
// ../src/nb/app/js/view/Page.js
// module id = 216
// module chunks = 35